<template>
  <el-container>
    <el-header>
      <div class="header">
        <div>
          <span>账户列表</span>
        </div>
        <div>
          <el-input
            v-model="search"
            size="mini"
            placeholder="输入用户名搜索"
            style="width:200px;"/>
        </div>
      </div>

      <el-divider></el-divider>
    </el-header>
    <el-main>

      <el-table
        v-loading="loading"
        :data="tableData.filter(data => !search || data.username.toLowerCase().includes(search.toLowerCase()))"
        style="width: 100%">
        <el-table-column
          prop="id"
          label="ID"
          max-width="120"
          min-width="50">
        </el-table-column>
        <el-table-column
          prop="username"
          label="用户名"
          max-width="240"
          min-width="100">
        </el-table-column>
        <el-table-column
          prop="belongDealer"
          label="所属经销商"
          max-width="340"
          min-width="160">
        </el-table-column>
        <el-table-column
          prop="role"
          label="用户角色"
          max-width="200"
          min-width="70">
        </el-table-column>


        <el-table-column
          v-if="userRole"
          fixed="right"
          label="操作"

          min-width="80">
          <template slot-scope="scope">

            <el-button @click="handleResetPsw(scope.row)" type="text" size="small"
                       style="margin-bottom: 1px;padding: 1px">重置密码
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="userCount">
        </el-pagination>
      </div>
      <div class="pagination2">
        <el-pagination
          small
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="size"
          layout=" total,prev, pager, next"
          :total="userCount">
        </el-pagination>
      </div>
    </el-main>

  </el-container>
</template>


<script>
  export default {
    name: "Account",
    data() {
      return {
        tableData: [],
        search: '',
        userCount: 0,
        currentPage: 1,
        size: 10,
        user: '',
        userRole: false,
        form: {},
        formLabelWidth: '120px',
        dialogFormVisible: false,
        loading: false,
      }
    },
    methods: {
      handleSizeChange(val) {
        this.size = val;
        this.loadAccount(this.currentPage, this.size);
        // console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.loadAccount(this.currentPage, this.size);
        // console.log(`当前页: ${val}`);
      },
      count() {
        this.$http.get("https://yuanteng.tech:8081/user/count").then(res => {
          this.userCount = res.data;
        })
      },
      loadAccount(page, size) {
        this.loading = true
        page = page == 1 ? 1 : this.currentPage;   //当前页
        size = size == 10 ? 10 : this.size;        //每页多少条
        this.$http.get("https://yuanteng.tech:8081/user/find?currentPage=" + page + "&sizePage=" + size).then(res => {
          this.tableData = res.data;
        }).finally(() => {
          this.loading = false
        });
      },
      //删除客户信息
      /*handleDelete(row) {
        this.loading = true
        this.$http.get("https://yuanteng.tech:8081/user/delete?id=" + row.id).then(res => {
          if (res.data.status) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            });
            this.loadAccount();
            this.count()
          } else {
            this.$message.error(res.data.msg);
          }
        }).finally(() => {
          this.loading = false
        })
      },
      //删除 操作确认弹出框
      open(row) {
        this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.handleDelete(row);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
*/

      //重置密码
      handleResetPsw(row) {
        this.loading = true;
        this.$http.get("https://yuanteng.tech:8081/user/resetPsw?id=" + row.id).then(res => {
          if (res.data.status) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            });
            this.loadAccount();
            this.count()
          } else {
            this.$message.error(res.data.msg);
          }
        }).finally(() => {
          this.loading = false
        })
      },

    },
    created() {
      this.user = JSON.parse(window.localStorage.getItem('access-admin')) || {};
      this.userRole = decodeURIComponent(window.atob(this.user.role)) == "ADMIN"
      this.count();
      this.loadAccount();
    }
  }
</script>

<style scoped>
  .el-main {
    padding-top: 10px;
    margin-bottom: 20px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .el-button {
    margin-bottom: 15px;
  }

  .el-divider {
    margin-bottom: 2px;
  }

  /deep/ .el-dialog {
    width: 24%;
  }

  .pagination {
    margin-top: 20px;
    text-align: right;
  }

  .pagination2 {
    margin-top: 20px;
    text-align: right;
    display: none;
  }

  @media screen and (max-width: 768px) {
    .pagination {
      display: none;
    }

    .pagination2 {
      display: block;
    }

    .el-input {
      width: 160px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Account.vue